import React from 'react';
import { Star } from 'lucide-react';

const ReviewBanner = () => (
  <section
    className="bg-[#3D5A47] py-3.5 md:py-4 border-y border-[#B5D43B]/30"
    data-testid="review-banner"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-2.5 md:gap-3 text-center">
      <div className="flex gap-0.5 flex-shrink-0">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-[#FBBC05] text-[#FBBC05]" />
        ))}
      </div>
      <span className="text-sm md:text-lg font-bold text-white tracking-wide">
        Backed by 5-Star Reviews from Happy Homeowners
      </span>
    </div>
  </section>
);

export default ReviewBanner;
